function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.4891 50.7496C10.7363 49.2978 12.7384 50.1777 13.5381 48.8406C14.0114 48.052 13.3963 47.6189 13.8346 46.002C14.0256 45.2975 14.3217 44.2201 15.2902 43.561C16.2904 42.8793 17.6885 42.8335 18.6937 43.3089C19.5621 43.7196 19.8234 44.3703 20.2298 44.2362C20.6716 44.0895 20.471 43.275 21.1283 42.0798C21.3544 41.6637 21.6768 41.0882 22.3295 40.6899C23.3146 40.0931 24.4139 40.3076 24.7011 40.3639C24.9695 40.4155 25.3254 40.5211 26.1442 40.9836C28.15 42.1121 28.1047 42.668 28.8614 42.7665C30.1866 42.9456 30.6378 41.3014 32.3047 41.2446C33.3596 41.208 34.172 41.8432 34.7246 42.2761C35.1447 42.6086 36.6425 43.8734 37.3245 47.1288C38.2368 51.4719 36.8262 55.1977 36.259 56.6448C35.1404 59.4878 33.6823 63.2079 29.7014 65.2119C29.4888 65.3163 25.1348 67.4367 20.7711 65.942C19.3802 65.4683 18.0254 64.6351 17.5075 64.3149C15.8407 63.2923 14.724 62.2831 13.9039 61.5313C12.7973 60.5184 11.6576 59.4606 10.5228 57.7818C9.61892 56.4465 8.92603 55.3992 8.78224 53.8544C8.71416 53.1402 8.62946 51.7446 9.4891 50.7496Z",
  fill: "#88B5E1",
  stroke: "url(#paint0_linear)",
  strokeWidth: 3,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.8219 53.2106C22.0088 53.6208 20.7126 51.4431 18.7882 52.1772C18.0231 52.468 17.5557 53.067 17.2332 53.4835C17.1049 53.6487 16.0807 55.0093 16.1722 56.8683C16.2909 59.2004 18.0792 60.6737 18.9561 61.3938C20.3068 62.5012 21.7163 62.9795 22.6685 63.1955C23.4411 63.4019 25.3173 63.7872 27.4061 62.9886C29.4093 62.2206 30.4744 60.7999 31.1269 59.9245C32.5782 57.9793 32.9242 56.0887 32.9902 55.7015C33.2239 54.3227 33.4942 52.6808 32.525 51.1472C31.5577 49.6187 29.4752 48.387 27.8262 48.8748C25.6258 49.5202 25.9127 52.7351 23.8219 53.2106Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.7464 52.9642C16.0772 53.6979 15.8465 54.7519 15.174 55.3334C14.2624 56.1197 12.8536 55.7547 12.0556 55.1597C11.1579 54.4925 10.5386 53.1746 10.9641 52.4429C11.6276 51.2966 15.023 51.3711 15.7464 52.9642Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.007 48.9066C32.2625 49.2071 31.2193 48.9271 30.6676 48.2269C29.9194 47.279 30.3492 45.8925 30.9769 45.1225C31.6837 44.256 33.0283 43.6954 33.737 44.1519C34.8524 44.8718 34.6271 48.2587 33.007 48.9066Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.2375 48.7499C20.0329 49.5275 19.1881 50.199 18.2987 50.2219C17.0949 50.255 16.2336 49.0862 15.9908 48.1222C15.7167 47.0386 16.0681 45.6234 16.8601 45.3286C18.095 44.8583 20.6775 47.0586 20.2375 48.7499Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.8536 47.331C25.3668 47.971 24.3243 48.2646 23.4951 47.9477C22.3691 47.5156 22.0286 46.1036 22.1762 45.1192C22.3432 44.0142 23.2092 42.8465 24.054 42.8736C25.3763 42.9174 26.9144 45.9459 25.8536 47.331Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M56.6789 94.3496L63.5854 125.183L81.2882 154.033L132.138 157.848L144.591 146.043V120.62L138.337 94.0234L80.5353 78.4688L52.5531 85.6613",
  fill: "#C0D6E8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M137.674 92.7388C144.792 98.4758 149.349 104.228 152.1 108.228C157.094 115.496 162.469 123.311 159.844 130.544C159.654 131.071 157.817 135.914 153.35 137.32C148.175 138.946 141.243 135.397 137.072 127.894",
  fill: "#C0D6E8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M137.674 92.7388C144.792 98.4758 149.349 104.228 152.1 108.228C157.094 115.496 162.469 123.311 159.844 130.544C159.654 131.071 157.817 135.914 153.35 137.32C148.175 138.946 141.243 135.397 137.072 127.894",
  stroke: "black",
  strokeWidth: 7,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M144.37 136.09C144.526 143.98 145.002 150.279 145.404 154.541C145.911 159.911 146.548 164.745 145.514 171.295C144.842 175.581 143.818 178.261 141.916 180.365C141.233 181.117 139.195 183.306 136.023 183.702C132.715 184.119 130.206 182.337 129.202 181.624C122.135 176.61 122.632 163.957 122.677 163.103",
  fill: "#C0D6E8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M144.37 136.09C144.526 143.98 145.002 150.279 145.404 154.541C145.911 159.911 146.548 164.745 145.514 171.295C144.842 175.581 143.818 178.261 141.916 180.365C141.233 181.117 139.195 183.306 136.023 183.702C132.715 184.119 130.206 182.337 129.202 181.624C122.135 176.61 122.632 163.957 122.677 163.103",
  stroke: "black",
  strokeWidth: 7,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M60.2075 111.496C59.7759 115.34 59.3041 120.34 58.9678 126.197C58.752 130.017 58.4558 135.307 58.5311 141.957C58.6265 150.666 59.3743 156.227 60.865 167.35C61.3268 170.798 62.1249 176.274 65.8291 181.067C67.2445 182.899 68.6449 184.064 70.3665 184.776C74.2514 186.388 77.8953 184.922 78.4776 184.676C81.1127 183.567 82.5632 181.68 83.4115 180.545C88.1295 174.251 87.3616 165.904 87.0253 163.279",
  fill: "#C0D6E8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M60.2075 111.496C59.7759 115.34 59.3041 120.34 58.9678 126.197C58.752 130.017 58.4558 135.307 58.5311 141.957C58.6265 150.666 59.3743 156.227 60.8651 167.35C61.3268 170.798 62.1249 176.274 65.8291 181.067C67.2445 182.899 68.6449 184.064 70.3665 184.776C74.2514 186.388 77.8953 184.922 78.4776 184.676C81.1127 183.567 82.5632 181.68 83.4115 180.545C88.1295 174.251 87.3616 165.904 87.0253 163.279",
  stroke: "black",
  strokeWidth: 7,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M60.9253 82.2834C55.1783 77.3345 47.8301 75.8136 42.2839 78.5391C41.2097 79.0661 37.1943 81.2294 35.6133 85.9023C33.7662 91.3632 36.6222 96.1666 37.2245 97.1755C38.6248 99.5245 40.3615 100.925 41.8271 102.004C45.0344 104.373 50.8969 108.148 60.2126 111.495",
  fill: "#C0D6E8"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M60.9253 82.2834C55.1783 77.3345 47.8301 75.8136 42.2839 78.5391C41.2097 79.0661 37.1943 81.2294 35.6133 85.9023C33.7662 91.3632 36.6222 96.1666 37.2245 97.1755C38.6248 99.5245 40.3615 100.925 41.8271 102.004C45.0344 104.373 50.8969 108.148 60.2126 111.495",
  stroke: "black",
  strokeWidth: 7,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M144.175 7.92354C144.917 8.25983 146.639 9.24862 149.023 16.8126C150.047 20.0601 151.206 24.5723 151.854 30.1487C152.727 37.7027 152.742 37.1104 153.47 40.2524C154.484 44.6393 155.267 46.15 156.281 51.2596C156.748 53.5986 157.099 55.3654 157.305 57.7244C157.606 61.1174 158.028 65.9158 156.296 71.3717C154.82 76.0195 152.451 79.0511 150.233 81.877C147.176 85.7769 144.144 88.2715 142.593 89.466C139.672 91.7096 136.907 93.2355 134.718 94.2644C132.068 95.5895 128.434 97.1656 123.967 98.4455C121.934 99.0277 115.234 100.835 106.184 100.87C102.083 100.885 94.986 100.86 86.383 98.0389C79.9986 95.9459 75.5616 93.2305 72.2388 91.1676C68.369 88.7634 64.725 86.4645 60.9255 82.2785C58.8676 80.0098 56.1723 76.9832 54.3453 72.1748C52.5434 67.4266 52.5383 63.4363 52.5584 62.3521C52.6237 58.3167 53.6476 55.4055 55.0128 51.6411C57.6479 44.3582 59.2992 44.3532 60.5089 39.2586C61.2417 36.1818 60.6093 36.3174 61.0309 27.7646C61.4977 18.3134 62.4262 15.0609 62.7776 13.8964C63.9922 9.91618 65.3324 5.77531 68.8358 4.43517C70.9037 3.64213 73.0469 4.11394 74.5126 4.43517C77.4739 5.08767 79.4364 6.5834 80.5708 7.46177C82.714 9.13318 83.9086 10.8548 85.0078 12.471C86.0769 14.042 87.4572 16.4111 88.5212 19.5732C91.332 19.3021 94.9358 19.0913 99.1219 19.1967C100.246 19.2218 104.964 19.3624 111.233 20.3311C115.188 20.9434 120.238 21.9623 125.995 23.7392C126.472 21.6512 127.476 18.4037 129.779 15.0308C130.688 13.7057 131.752 12.1698 133.609 10.7444C134.317 10.2123 139.933 5.99615 144.175 7.92354Z",
  fill: "#C0D6E8",
  stroke: "black",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M117.045 65.9812C121.598 65.7151 123.876 65.5846 125.583 65.9611C126.637 66.192 133.709 67.753 136.354 72.9679C139.968 80.0802 132.284 90.2341 131.927 90.6808C126.396 97.6224 118.446 99.3942 113.873 100.413C107.659 101.798 102.695 101.307 99.0313 100.915C92.6217 100.232 87.4519 99.3842 82.4276 95.8557C77.8953 92.6735 74.9138 88.1863 74.9138 88.1863C74.8134 88.0357 74.7382 87.9202 74.688 87.8399C72.2486 84.0605 71.1996 80.4918 70.7127 78.193C70.4266 77.0185 69.7792 73.6656 71.3602 69.9564C71.7367 69.073 72.9011 66.4178 75.742 64.5206C78.4474 62.7187 81.1276 62.6032 83.6975 62.4928C87.0754 62.3472 89.6202 63.065 91.1661 63.4966C94.3132 64.385 98.2985 65.3789 101.476 68.7518C102.018 69.324 102.409 69.8359 102.655 70.1722C102.981 69.9112 103.463 69.5398 104.086 69.1383C106.264 67.7429 109.361 66.4329 117.045 65.9812Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M126.823 144.311C127.842 147.809 127.892 150.982 127.907 152.904C127.937 156.242 127.515 159.037 127.094 161.045L114.797 163.941L98.5193 164.574L87.8484 163.128L83.7778 161.231L82.3323 159.063C81.9659 157.853 81.5342 156.136 81.2933 154.043C80.9921 151.468 80.3848 145.37 83.6724 139.026C86.3426 133.871 90.3229 131 92.4611 129.685C94.8402 128.701 99.3575 127.211 105.12 127.587C112.237 128.054 117.276 131.105 119.45 132.611C121.944 134.95 125.227 138.83 126.823 144.311Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M126.542 161.332C123.46 162.561 119.289 163.906 114.225 164.649C109.662 165.322 106.134 165.247 104.161 165.201C98.5545 165.061 94.3132 164.213 91.0809 163.555C87.5523 162.832 84.606 162.009 82.4277 161.337",
  stroke: "black",
  strokeWidth: 7,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M144.571 34.1039C144.626 32.8843 144.601 30.9569 144.104 28.643C143.738 26.9315 142.427 20.8431 139.441 20.5871C138.944 20.542 138.111 20.6373 136.951 21.5609C136.264 22.2033 135.325 23.2323 134.683 24.6477C133.89 26.3894 133.915 27.9102 134.015 28.7986C137.534 30.5654 141.052 32.3372 144.571 34.1039Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M80.5354 23.227C77.3683 25.0238 74.2011 26.8207 71.034 28.6176C70.8533 28.0705 70.6023 27.2323 70.3915 26.1933C69.9599 24.0802 69.1719 20.2305 71.034 17.1386C71.4205 16.4911 72.0077 15.5525 73.112 15.2112C74.3366 14.8298 75.481 15.402 76.0783 15.7081C78.3771 16.8676 79.3208 19.2367 79.7875 20.4061C80.2543 21.5606 80.4451 22.5694 80.5354 23.227Z",
  fill: "black",
  stroke: "black",
  strokeMiterlimit: 10
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M119.997 60.9817C120.81 63.1299 123.947 64.2241 126.246 63.0044C128.59 61.7546 129.378 58.457 127.992 56.5748C127.029 55.2648 125.227 54.9235 123.882 55.1845C121.337 55.6814 119.088 58.5975 119.997 60.9817Z",
  fill: "black"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M83.8983 54.9738C84.7114 52.8255 87.8484 51.7314 90.1472 52.951C92.4912 54.2008 93.2792 57.4985 91.8939 59.3807C90.9302 60.6907 89.1283 61.032 87.7831 60.771C85.2384 60.2791 82.9898 57.3579 83.8983 54.9738Z",
  fill: "black"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M102.71 69.7002C103.102 69.7554 103.207 69.5044 104.045 69.1982C104.557 69.0125 104.989 68.8569 105.501 68.887C105.576 68.8921 106.856 68.9924 107.343 69.9812C107.664 70.6337 107.459 71.3063 107.343 71.6727C107.117 72.3854 106.691 72.8221 106.214 73.314C105.616 73.9314 105.049 74.2727 104.914 74.353C103.905 74.9553 102.996 75.0958 102.71 75.131C102.304 75.1862 102.063 75.2163 101.737 75.1661C100.898 75.0356 100.371 74.4985 99.7289 73.846C99.4077 73.5198 98.8606 72.9074 98.4239 72.009C98.178 71.5071 97.9923 71.1156 97.9622 70.5484C97.9471 70.2473 97.912 69.6249 98.3185 69.0627C98.5946 68.6762 98.9459 68.5006 99.0814 68.4353C99.2019 68.3751 99.6888 68.1542 100.316 68.2446C100.773 68.3098 101.079 68.5106 101.466 68.7716C102.284 69.3137 102.279 69.6399 102.71 69.7002Z",
  fill: "black"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M111.986 81.5705C111.539 81.8617 110.646 82.3535 109.421 82.469C107.855 82.6196 106.696 82.0624 106.214 81.8265C104.522 80.9933 103.704 79.6281 103.263 78.8752C102.219 77.0934 102.078 75.3617 102.078 74.4482C102.088 74.9201 102.093 77.7509 99.9751 79.6331C98.8558 80.6269 97.611 80.9482 97.3048 81.0184C96.823 81.1339 95.8392 81.3447 94.6346 81.0134C93.4199 80.6771 92.647 79.9744 92.3157 79.6281",
  stroke: "black",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M97.3399 45.7887C97.626 47.2292 96.9333 49.0612 95.6233 49.7237C93.6307 50.7326 90.9103 48.6848 89.6655 46.8929C88.8223 45.6833 87.7381 43.269 88.6516 42.2551C90.0821 40.669 96.6422 42.2903 97.3399 45.7887Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M113.165 47.1237C112.648 48.499 113.035 50.4163 114.219 51.2847C116.021 52.6047 119.043 51.0287 120.559 49.4677C121.588 48.4086 123.048 46.2052 122.315 45.0558C121.161 43.2539 114.425 43.7859 113.165 47.1237Z",
  fill: "white"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M72.901 92.4624C73.9902 96.006 75.6917 100.107 78.372 104.303C79.2604 105.693 81.514 109.066 85.2031 112.735C88.5711 116.088 91.678 118.241 93.3343 119.31C98.7199 122.794 101.922 124.862 106.093 125.153C113.978 125.695 120.393 119.541 126.08 114.085C130.105 110.22 132.454 106.647 133.458 105.016C136.033 100.84 137.489 96.9396 138.342 94.0284C135.958 95.3635 132.941 96.8542 129.342 98.1894C127.224 98.9724 124.489 99.8608 121.251 100.594C119.931 100.89 114.41 102.094 106.856 102.165C104.005 102.19 99.9246 102.21 94.6393 101.246C90.3127 100.458 86.8093 99.3086 84.3649 98.3751C79.7974 96.6284 75.9828 94.5103 72.901 92.4624Z",
  fill: "#9188AB",
  stroke: "black",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M144.175 7.92354C144.917 8.25983 146.639 9.24862 149.023 16.8126C150.047 20.0601 151.206 24.5723 151.854 30.1487C152.727 37.7027 152.742 37.1104 153.47 40.2524C154.484 44.6393 155.267 46.15 156.281 51.2596C156.748 53.5986 157.099 55.3654 157.305 57.7244C157.606 61.1174 158.028 65.9158 156.296 71.3717C154.82 76.0195 152.451 79.0511 150.233 81.877C147.176 85.7769 144.144 88.2715 142.593 89.466C139.672 91.7096 136.907 93.2355 134.718 94.2644C132.068 95.5895 128.434 97.1656 123.967 98.4455C121.934 99.0277 115.234 100.835 106.184 100.87C102.083 100.885 94.986 100.86 86.383 98.0389C79.9986 95.9459 75.5616 93.2305 72.2388 91.1676C68.369 88.7634 64.725 86.4645 60.9255 82.2785C58.8676 80.0098 56.1723 76.9832 54.3453 72.1748C52.5434 67.4266 52.5383 63.4363 52.5584 62.3521C52.6237 58.3167 53.6476 55.4055 55.0128 51.6411C57.6479 44.3582 59.2993 44.3532 60.5089 39.2586C61.2417 36.1818 60.6093 36.3174 61.0309 27.7646C61.4977 18.3134 62.4262 15.0609 62.7776 13.8964C63.9922 9.91618 65.3324 5.77531 68.8358 4.43517C70.9037 3.64213 73.0469 4.11394 74.5126 4.43517C77.4739 5.08767 79.4364 6.5834 80.5708 7.46177C82.714 9.13318 83.9086 10.8548 85.0078 12.471C86.0769 14.042 87.4572 16.4111 88.5212 19.5732C91.332 19.3021 94.9358 19.0913 99.1219 19.1967C100.246 19.2218 104.964 19.3624 111.233 20.3311C115.188 20.9434 120.238 21.9623 125.995 23.7392C126.472 21.6512 127.476 18.4037 129.779 15.0308C130.688 13.7057 131.752 12.1698 133.609 10.7444C134.317 10.2123 139.933 5.99615 144.175 7.92354Z",
  stroke: "black",
  strokeWidth: 7,
  strokeMiterlimit: 10
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M98.9998 109H102.261",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M109.358 109H112.62",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M100.632 109L101.75 114.607",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M110.991 109L109.669 114.607",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M105.585 109.298L102.006 114.701",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M105.854 109.298L109.442 114.701",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 2.24688,
  y1: 48.8519,
  x2: 44.5639,
  y2: 61.959,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9188AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5685B3"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  y: 45.5049,
  width: 40.0829,
  height: 31.0811,
  transform: "rotate(-19.6893 0 45.5049)",
  fill: "white"
})));

var SvgThiccLilDubs = function SvgThiccLilDubs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 190,
    viewBox: "0 0 165 190",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThiccLilDubs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thicc-lil-dubs.fcdd903b.svg";
export { ForwardRef as ReactComponent };